import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { NOTIFICATION_TYPES } from '../../../../constants';
import { useEmailDecisionMakerModal } from '../useEmailDecisionMakerModal';

type Props = {
	onDismiss?: () => void;
};

type UseEmailDecisionMakerNotificationReturn = ModelHookResult<
	undefined,
	{ handleClick: () => Promise<void>; handleDismiss: () => void }
>;

export function useEmailDecisionMakerNotification({ onDismiss }: Props = {}): UseEmailDecisionMakerNotificationReturn {
	const track = useTracking();
	const openModal = useEmailDecisionMakerModal();

	const pageData = useStarterDashboardV2PageData();

	const handleClick = useCallback(async () => {
		void track('petition_manage_notification_cta_click', {
			notification: NOTIFICATION_TYPES.emailDecisionMaker,
		});

		await openModal({ pageData });
	}, [track, openModal, pageData]);

	const handleDismiss = useCallback(() => {
		onDismiss?.();
	}, [onDismiss]);

	return {
		actions: { handleClick, handleDismiss },
	};
}
